document.addEventListener('DOMContentLoaded', function() {
    /*
    
    Пример использования блока
    <div class="ui-rating" data-val="4.55"></div>
    
    _____________________________________________________________________________________________________________
    
    Звёздочки подкрашиваются тёмным цветом с помощью вложенного блока с отдельным более тёмным фоном (см. стили).
    
    Есть особенность заполнения рейтинга. Поскольку между звёздочками есть пространство, простое применение ширины
    у вложенного блока даёт визуально некорректный результат – некоторая часть дробного рейтинга заполняется вне
    звёздочки.
    
    Поэтому делаем рассчёт, на сколько пикселей нужно скорректировать ширину в зависимости от значения.
    Так достигается верное заполнение рейтинга https://skrinshoter.ru/sNIxQ4orfgl
    
     */
    
    const maxRate = 5; // максимальная оценка
    
    function init(element) {
        if (element.classList.contains('ui-rating_inited')) {
            return;
        }
        
        const starPaddingSum = element.dataset.padding || 5; // пространство между звёздочками (в px)
        const val = parseFloat(element.dataset.val);
        if (val > 0) {
            const fractPart = val % 1;
            const correctionVal = 0.5 - fractPart;
            
            const valBlock = document.createElement('span');
            valBlock.classList.add('ui-rating__val');
            element.appendChild(valBlock);
            
            // заполнение рейтинга
            setTimeout(function() {
                valBlock.style.width = `calc(${val / maxRate * 100}% + ${starPaddingSum * correctionVal}px)`;
            }, 100);
        }
        
        element.classList.add('ui-rating_inited');
    }
    
    
    document.addEventListener('ab.rating.init', function(event) {
        const items = (event.detail.wrap || document).querySelectorAll('.ui-rating:not(.ui-rating_inited)');
        items.forEach(element => init(element));
    });
    
    
    // Запуск
    
    const ratingBlock = document.querySelectorAll(
        '.ui-rating:not(.ui-rating_inited):not([data-stop-start])');
    
    ratingBlock.forEach(element => {
        init(element)
    });
});
